import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { COLOR }           from '@/constants/colors';
import Prog_circular        from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleChart          from '@/components/SmartLink/charts/SingleChart.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'statisticsComponent',
  props: {
    rxbytes   : { required:true, type:Array },
    txbytes   : { required:true, type:Array },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      class: "ma-4 defaultCard",
      color: "bgtopology"
    }, {
      default: _withCtx(() => [
        (__props.rxbytes.length !== 0)
          ? (_openBlock(), _createBlock(SingleChart, {
              key: 0,
              name: 'rxbytes',
              "first-array": __props.rxbytes,
              title: 'RX (MBytes)',
              color: _unref(COLOR).single
            }, null, 8, ["first-array", "title", "color"]))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 1,
              class: "text-center",
              color: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_v_sheet, {
      class: "ma-4 defaultCard",
      color: "bgtopology"
    }, {
      default: _withCtx(() => [
        (__props.txbytes.length !== 0)
          ? (_openBlock(), _createBlock(SingleChart, {
              key: 0,
              name: 'txbytes',
              "first-array": __props.txbytes,
              title: 'TX (MBytes)',
              color: _unref(COLOR).single
            }, null, 8, ["first-array", "title", "color"]))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 1,
              class: "text-center",
              color: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 64))
}
}

})